import React from 'react';
import { FileText } from 'lucide-react';

export const MainEmpty = () => {
  return (
    <div className="flex-1 flex flex-col pt-20 pb-32 lg:pb-0 items-center justify-start text-center max-w-sm mx-auto opacity-70">
      <FileText className="w-12 h-12 text-slate-500 dark:text-slate-600 mb-6" strokeWidth={1} />
      <h3 className="text-lg font-medium text-slate-800 dark:text-slate-200 mb-2">Ready to work</h3>
      <p className="text-sm text-slate-700 dark:text-slate-400 leading-relaxed">Select a resume and paste a job description on the left to start analyzing.</p>
    </div>
  );
};
